import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  error: null,
  report: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.REPORT_FETCHING:
      return {
        ...state,
        fetching: payload,
        error: null,
      };
    case types.REPORT_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.REPORT_SUCCESS:
      return {
        ...state,
        report: payload,
      };
    case types.REPORT_CLEAR:
      return {
        ...state,
        report: null,
      };
    case types.REPORT_RESET_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/report/reducer.js